import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { Auth, API } from 'aws-amplify';
import { Table } from 'antd';


class Mappings extends React.Component {
  state = {
    data: [],
    next: '',
    limit: 20
  };

  componentWillMount() {
    const { userId } = this.props.match.params;
    const { next, limit } = this.state;
    API.get("api", "mappings", { queryStringParameters: { next, limit, userId }}).then(
      resp => {
        this.setState(resp);
      }
    );
  }

  render() {
    return (
      <div>
        <h1>Mappings</h1>
      </div>
    )
  }
}

export default Mappings;
